
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#4D4D4D"}},[_c('circle',{attrs:{"cx":"2","cy":"2","r":"2"}}),_c('circle',{attrs:{"cx":"8","cy":"2","r":"2"}}),_c('circle',{attrs:{"cx":"14","cy":"2","r":"2"}})])])
          )
        }
      }
    